import { Component, Prop, Vue } from 'vue-property-decorator'
import Control from '@/helpers/control'
import fetch from '@/helpers/fetch'
import LabelModified from '@/components/edit/LabelModified/index.vue'
import BadgeClient from '@/components/checking-accounts/BadgeClient/index.vue'

import FieldMoneyPortal from '@/components/edit/FieldMoneyPortal/index.vue'
import FieldPercentagePortal from '@/components/edit/FieldPercentagePortal/index.vue'
import FieldDatePortal from '@/components/edit/FieldDatePortal/index.vue'
import onInputCheckingAccounts from '@/views/CheckingAccounts/onInputCheckingAccounts'

import tableHelper from '@/helpers/table'

@Component({
	components: {
		LabelModified,
		BadgeClient,
		FieldMoneyPortal,
		FieldPercentagePortal,
		FieldDatePortal,
	},
})
export default class TableHead extends Vue {
	@Prop() reports

	openLink(id) {
		const link = `/clientes/${id}/`
		window.open(link, '_blank')
	}

	calculateTotalTrials(t) {
		return t.groupsRelations.filter(
			(item) => !item?.trial?.closed && !item?.trial?.mainTrial_trial_id,
		)?.length
	}

	calculateReportFrequency(reportInfo) {
		const months = [
			reportInfo.reportSendingOnJan,
			reportInfo.reportSendingOnFeb,
			reportInfo.reportSendingOnMar,
			reportInfo.reportSendingOnApr,
			reportInfo.reportSendingOnMay,
			reportInfo.reportSendingOnJun,
			reportInfo.reportSendingOnJul,
			reportInfo.reportSendingOnAug,
			reportInfo.reportSendingOnSep,
			reportInfo.reportSendingOnOct,
			reportInfo.reportSendingOnNov,
			reportInfo.reportSendingOnDec,
		]

		const monthsSent = months.filter((month) => month).length

		if (monthsSent === 12) {
			return 'Mensal'
		} else if (monthsSent === 0) {
			return 'Nunca'
		}

		const monthsNames = [
			'Jan',
			'Fev',
			'Mar',
			'Abr',
			'Mai',
			'Jun',
			'Jul',
			'Ago',
			'Set',
			'Out',
			'Nov',
			'Dez',
		]

		let result: any[] = []

		months.forEach((element, index) => {
			if (element) {
				result.push(monthsNames[index])
			}
		})

		return result.join('/')
	}
}
